
require("./../node_modules/@module-federation/nextjs-mf/src/include-defaults.js");
import { GetServerSidePropsContext } from 'next';
import authCookie from 'utils/authCookie';
import dynamic from 'next/dynamic';
import { ThemeProvider } from 'styled-components';
import { privacyPageTheme, Theme } from 'config/theme';

import Privacy from 'constants/contents/privacy';

interface PrivacyPageProps {
  isLoggedIn: boolean;
  mode?: Theme;
}

const UserArticleLayout = dynamic(
  () => import('features/static/UserArticleLayout'),
);

const ArticleLayout = dynamic(() => import('features/static/ArticleLayout'));

const PrivacyPage = ({ isLoggedIn, mode }: PrivacyPageProps) => {
  if (isLoggedIn) {
    return <UserArticleLayout source={<Privacy />} title="Privacy" />;
  }

  return (
    <ThemeProvider theme={privacyPageTheme[mode] || privacyPageTheme.light}>
      <ArticleLayout source={<Privacy />} title="Privacy" />
    </ThemeProvider>
  );
};

export async function getServerSideProps(context: GetServerSidePropsContext) {
  const isLoggedIn = Boolean(authCookie.getIsLoggedIn(context));
  const mode = context.query?.mode || '';

  return {
    props: {
      isLoggedIn,
      mode,
    },
  };
}

export default PrivacyPage;
